<template>
  <div id="app">
    <h1 style="text-align: center;">Demo H5</h1>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    const redirectTo = this.$route.query.redirect_to

    if (redirectTo !== undefined) {
      switch (redirectTo) {
        case 'buy-load':
          this.$router.push('/buy-load/input-number')
          break
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue